import React, { FunctionComponent } from "react"
import { Helmet } from "react-helmet"
import { useAuth } from "../common/hooks/useAuth"

export interface TitleProps {
    text?: string
}

export const Title: FunctionComponent<TitleProps> = ({ text }) => {
    const { branding } = useAuth()
    const baseTitle = branding?.name ?? "Lumen"
    const pageTitle = text ? `${baseTitle} | ${text}` : baseTitle

    const onLoginPage = text === "Login"

    return (
        <Helmet>
            <title>{onLoginPage ? "Login" : pageTitle}</title>
        </Helmet>
    )
}
